// Viewport
if(navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)){
  $('head').prepend('<meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1, minimum-scale=1, maximum-scale=1, viewport-fit=cover">');
}else if(navigator.userAgent.indexOf('iPad') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) || navigator.userAgent.indexOf('A1_07') > 0 || navigator.userAgent.indexOf('SC-01C') > 0){
  $('head').prepend('<meta name="viewport" content="width=1280px">');
}


// Ready Init
function readyInit(){
  // Navigation Control
  var header = $('#header'),
      nav = $('#nav'),
      toggle = $('#nav-toggler'),
      dropdown = $('#nav-list'),
      hash = $('.nav-list-item a');

  function navControl(){
    if(toggle.css('display') == 'none'){
      toggle.removeClass('active');
      dropdown.removeAttr('style').find('a').removeClass('anima');
    }
  }navControl();
  $(window).on('resize', navControl);

  toggle.on('click', function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      dropdown.stop().slideDown(300, 'easeInOutQuad', function(){
        $(this).find('a').each(function(i){
          $(this).delay(120*i).queue(function(){ $(this).stop().addClass('anima');});
        });
      });
    }else{
      dropdown.stop().slideUp(300, 'easeInOutQuad', function(){
        $(this).find('a').removeClass('anima');
      });
    }
  });

  hash.on('click', function(){
    if(toggle.css('display') == 'block'){
      toggle.removeClass('active');
      dropdown.stop().slideUp(300, 'easeInOutQuad', function(){
        $(this).find('a').removeClass('anima');
      });
    }
  });


  // Bideo
  var introBideo = new Bideo();
  introBideo.init({
    videoEl: document.querySelector('#intro-mov-bideo-video'),
    resize: true,
    src: [{ src: 'http://nichigo-express.jp/wp/wp-content/themes/happily/mov/intro.mp4', type: 'video/mp4'}],
    onLoad: function(){ document.querySelector('#intro-mov-bideo-cover').style.display = 'none';}
  });


  //Rellax
  var tochildRx = new Rellax('#tochild-flex-img', {speed: 2, center: true});
  var featureRx = new Rellax('.feature-flex-img', {speed: 2, center: true});
  var qureoRx = new Rellax('.qureo-flex-img', {speed: 2, center: true});


  // ToTop & Hash
  var totop = $('#totop');
  $(window).on('scroll', function(){
    if($(this).scrollTop() > 600){totop.addClass('active');}
    else{totop.removeClass('active');}
  });
  totop.on('click', function(){
    $('html, body').stop().animate({scrollTop: 0}, 600, 'easeInOutQuad');
    return false;
  });
  $('a[href^="#"]').on('click', function(){
    var href= $(this).attr('href'),
        target = $(href == '#' || href == '' ? 'html' : href),
        position = target.offset().top;
    $('html, body').animate({scrollTop: position}, 600, 'easeInOutQuart');
    return false;
   });

   // GoogleMap
   var latlng, icon, map, marker;

   latlng = new google.maps.LatLng(33.669339, 130.419014);
   icon = { url: 'http://nichigo-express.jp/wp/wp-content/themes/happily/img/pin.png', scaledSize : new google.maps.Size(32, 46)};

   map = new google.maps.Map(document.getElementById('contact-flex-map-canvas'), {
     center: latlng,
     zoom: 17,
     mapTypeId: google.maps.MapTypeId.ROADMAP,
     scrollwheel: false,
     mapTypeControl: false,
     streetViewControl: false
   });
   marker = new google.maps.Marker({
     position: latlng,
     map: map,
     icon: icon,
     title: 'Happily'
   });
}


// Load Init
function loadInit(){
  //Inview
  var i;
  $('#intro').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){ $(this).addClass('anima');}
  });
  $('#tochild').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){ $(this).addClass('anima');}
  });
  $('#feature').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).addClass('anima').find('.flex-item-md-4').each(function(i){
        $(this).delay(300*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('#qureo').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).addClass('anima').find('.qureo-flex').each(function(i){
        $(this).delay(300*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('#flow').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).addClass('anima').find('.flex-item-md-20').each(function(i){
        $(this).delay(300*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('#contact').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){ $(this).addClass('anima');}
  });
}


$(document).ready(readyInit);
$(window).on('load', loadInit);
